export default {
  // Navigation
  nav_home: 'ホーム',
  nav_dashboard: 'ダッシュボード',
  nav_orders: '注文',
  nav_wallet: 'ウォレット',
  nav_analytics: '分析',
  nav_referral: '紹介',
  nav_account: 'アカウント',
  nav_notifications: '通知',
  nav_support: 'サポート',
  nav_logout: 'ログアウト',
  nav_login: 'ログイン',
  nav_signup: '登録',

  // Dashboard
  dashboard_welcome: 'おかえりなさい',
  dashboard_total_earnings: '総収益',
  dashboard_pending_orders: '保留中の注文',
  dashboard_completed_orders: '完了した注文',
  dashboard_commission_rate: '手数料率',
  dashboard_quick_actions: 'クイックアクション',
  dashboard_recent_orders: '最近の注文',
  dashboard_recent_activity: '最近のアクティビティ',
  dashboard_wallet_balance: 'ウォレット残高',
  dashboard_deposit: '入金',
  dashboard_withdraw: '出金',
  dashboard_view_all: 'すべて表示',

  // Orders
  orders_title: 'マイ注文',
  orders_all: 'すべての注文',
  orders_pending: '保留中',
  orders_completed: '完了',
  orders_cancelled: 'キャンセル',
  orders_order_id: '注文ID',
  orders_platform: 'プラットフォーム',
  orders_amount: '金額',
  orders_commission: '手数料',
  orders_status: 'ステータス',
  orders_date: '日付',
  orders_no_orders: '注文が見つかりません',
  orders_step_1: '製品詳細の確認',
  orders_step_2: '注文情報の照合',
  orders_step_3: 'プラットフォームへの接続',
  orders_step_4: 'プロモーションの送信',
  orders_step_5: 'SEOインデックス作成',
  orders_step_6: '視認性の向上',
  orders_step_7: '最終化と確認',
  orders_btn_optimize: '注文を最適化',
  orders_btn_claim_commission: '報酬を受け取る',
  orders_btn_task_completed: 'タスク完了',
  orders_price_label: '注文価格',
  orders_commission_rate_label: '報酬率',

  // Wallet
  wallet_title: 'マイウォレット',
  wallet_available_balance: '利用可能残高',
  wallet_pending_balance: '保留中の残高',
  wallet_total_withdrawn: '総出金額',
  wallet_deposit_now: '今すぐ入金',
  wallet_withdraw_now: '今すぐ出金',
  wallet_transaction_history: '取引履歴',
  wallet_deposit_history: "Deposit History",
  wallet_withdrawal_history: '出金履歴',
  wallet_deposit_desc: "利用可能な支払い方法を使用してウォレットにお金を追加します。",
  wallet_no_deposits: "入金はありません。",
  wallet_withdraw_history: "出金履歴",
  wallet_withdraw_desc: "ウォレットからお金を引き出します。",
  wallet_no_withdrawals: "出金はありません。",
  wallet_no_withdrawals_desc: "まだ引き出しを行っていません。",
  withdrawal_restricted_title: '出金制限',
  withdrawal_restricted_message: '現在、あなたのアカウントでは出金が利用できません。詳細については、カスタマーサポートにお問い合わせください。',

  // Analytics
  analytics_title: '分析',
  analytics_earnings_overview: '収益概要',
  analytics_platform_breakdown: 'プラットフォーム別内訳',
  analytics_performance_metrics: 'パフォーマンス指標',
  analytics_top_products: 'トップ製品',
  analytics_this_month: '今月',
  analytics_last_month: '先月',
  analytics_total_revenue: '総収益',
  analytics_avg_order_value: '平均注文額',

  // Referral
  security_row_title: 'セキュリティ設定',
  security_login_pw: 'ログインパスワード',
  security_login_pw_desc: 'アカウントのログインパスワードを変更します',
  security_change_btn: '変更',
  security_set_withdrawal_pw_title: '出金パスワードの設定',
  security_set_withdrawal_pw_desc: '出金を承認するための専用のPINを作成します',
  security_set_withdrawal_pw_btn: 'PINを設定',
  security_change_withdrawal_pw_title: '出金パスワードの変更',
  security_change_withdrawal_pw_desc: '既存の出金PINを更新します',
  security_change_withdrawal_pw_btn: '変更',
  security_modal_set_withdrawal_title: '出金パスワードの設定',
  security_modal_set_withdrawal_subtitle: 'このPINは、出金を行うたびに必要になります。',
  security_modal_change_withdrawal_title: '出金パスワードの変更',
  security_field_current_pin: '現在の出金PIN',
  security_field_new_pin: '新しい出金PIN',
  security_field_new_pin_6: '新しい出金PIN（6桁）',
  security_field_confirm_pin: 'PINの確認',
  security_field_confirm_new_pin: '新しいPINの確認',
  security_placeholder_pin_dots: '......',
  security_pw_current: '現在のパスワード',
  referral_active_referrals: 'アクティブな紹介',
  referral_referral_earnings: '紹介収益',
  referral_invite_friends: '友達を招待',

  // Account
  account_title: 'アカウント設定',
  account_profile: 'プロフィール',
  account_security: 'セキュリティ',
  account_notifications: '通知',
  account_kyc: 'KYC認証',
  account_phone: '電話番号',
  account_two_factor: '二要素認証',
  account_save_changes: '変更を保存',
  account_cancel: 'キャンセル',

  // Support
  support_btn_send: '返信を送信',
  support_edit_message: 'メッセージを編集',
  support_delete_message: 'メッセージを削除',
  support_delete_confirm: 'このメッセージを削除してもよろしいですか？',
  support_message_updated: 'メッセージを更新しました',
  support_message_deleted: 'メッセージを削除しました',
  support_err_already_read: '既読のメッセージは編集できません。',
  support_title: 'サポートセンター',
  support_faq: 'よくある質問',
  support_contact_us: 'お問い合わせ',
  support_live_chat: 'ライブチャット',
  support_ticket_tracker: 'チケット追跡',
  support_submit_ticket: 'チケットを送信',

  // Auth
  auth_email: 'メールアドレス',
  auth_password: 'パスワード',
  auth_confirm_password: 'パスワードを確認',
  auth_forgot_password: 'パスワードをお忘れですか？',
  auth_remember_me: 'ログイン状態を保持',
  auth_login_button: 'ログイン',
  auth_signup_button: '登録',
  auth_already_have_account: 'すでにアカウントをお持ちですか？',
  auth_dont_have_account: 'アカウントをお持ちでないですか？',
  auth_reset_password: 'パスワードをリセット',
  auth_verify_email: 'メールを確認',

  // Common
  common_loading: '読み込み中...',
  common_save: '保存',
  common_cancel: 'キャンセル',
  common_delete: '削除',
  common_edit: '編集',
  common_view: '表示',
  common_search: '検索',
  common_filter: 'フィルター',
  common_export: 'エクスポート',
  common_import: 'インポート',
  common_submit: '送信',
  common_close: '閉じる',
  common_confirm: '確認',
  common_success: '成功',
  common_error: 'エラー',
  common_warning: '警告',

  // Homepage
  home_hero_title: 'トップEコマースプラットフォームから手数料を獲得',
  home_hero_subtitle: 'Walmart、eBay、AliExpressから毎日手数料を獲得している数千人のユーザーに参加',
  home_get_started: '今すぐ始める',
  home_learn_more: '詳細を見る',
  home_how_it_works: '仕組み',
  home_features: '機能',
  home_commission_tiers: '手数料ティア',
  home_testimonials: 'ユーザーの声',
  home_faq: 'よくある質問',
  home_cta_title: '収益を始める準備はできましたか？',
  home_cta_subtitle: '今日コミュニティに参加して手数料を獲得し始めましょう',

  // Feature Section
  feature_1_title: '即時支払い',
  feature_1_desc: '取引完了後、即座に収益が反映されます。遅延なくいつでも出金可能です。',
  feature_1_detail_1: 'リアルタイムの手数料反映',
  feature_1_detail_2: '複数の出金オプション',
  feature_1_detail_3: '最低出金額制限なし',
  feature_2_title: '安全なプラットフォーム',
  feature_2_desc: '銀行レベルの暗号化でデータと収益を保護します。世界中の数千人のユーザーに信頼されています。',
  feature_2_detail_1: 'SSL暗号化有効',
  feature_2_detail_2: '二要素認証',
  feature_2_detail_3: '定期的なセキュリティ監査',
  feature_2_detail_4: 'データプライバシー保証',
  feature_3_title: '柔軟な時間',
  feature_3_desc: 'いつでも、どこでも好きな時に働けます。固定のスケジュールなしで、自分のペースで注文を完了できます。',
  feature_3_detail_1: '固定の勤務時間なし',
  feature_3_detail_2: 'どこからでも勤務可能',
  feature_3_detail_3: '自分のペースを選択',
  feature_3_detail_4: '週末も利用可能',
  feature_4_title: '階層的な収益',
  feature_4_desc: 'より多くの注文を完了することで、より高い手数料率をアンロックします。ティアアップグレードごとに収入を増やしましょう。',
  feature_4_detail_1: 'ティアベースの手数料率',
  feature_4_detail_2: '自動ティアアップグレード',
  feature_4_detail_3: 'パフォーマンス報酬',
  feature_5_title: 'グローバルプラットフォーム',
  feature_5_desc: '世界中のどこからでも国際的なブランドと連携できます。多通貨対応。',
  feature_5_detail_1: '世界中で利用可能',
  feature_5_detail_2: '多通貨対応',
  feature_5_detail_3: 'ローカルの支払い方法',
  feature_6_title: '24/7 サポート',
  feature_6_desc: '私たちの専任サポートチームが常にサポートいたします。ライブチャット、メール、または電話でサポートを受けてください。',
  feature_6_detail_1: 'ライブチャット利用可能',
  feature_6_detail_2: '24/7 メールサポート',
  feature_6_detail_3: '電話アシスタンス',
  feature_6_detail_4: '包括的なFAQ',
  feature_7_title: '紹介プログラム',
  feature_7_desc: '友達を招待して追加の収入を得ましょう。紹介したユーザーの収益から一生涯の手数料を受け取れます。',
  feature_7_detail_1: '一生涯の紹介利益',
  feature_7_detail_2: '無制限の紹介',
  feature_7_detail_3: '簡単な共有ツール',
  feature_7_detail_4: 'ボーナスインセンティブ',
  feature_8_title: '多通貨対応',
  feature_8_desc: '主要な通貨と支払い方法をサポートしています。あなたに最適なものを選択してください。',
  feature_8_detail_1: 'USD, EUR, GBP 対応',
  feature_8_detail_2: '銀行振込利用可能',
  feature_8_detail_3: '電子ウォレット統合',
  feature_8_detail_4: 'クリプトオプション近日公開',
  feature_9_title: '即時通知',
  feature_9_desc: '新しい注文、収益、アカウントアクティビティのリアルタイムアラートで最新情報を把握しましょう。',
  feature_9_detail_1: 'プッシュ通知',
  feature_9_detail_2: 'メールアラート',
  feature_9_detail_3: 'SMSアップデート',
  feature_9_detail_4: 'アプリ内メッセージ',

  // Footer
  footer_about: '会社概要',
  footer_terms: '利用規約',
  footer_privacy: 'プライバシーポリシー',
  footer_contact: 'お問い合わせ',
  footer_copyright: '全著作権所有',

  // Redesigned Footer
  footer_stay_loop_title: '最新情報を入手',
  footer_stay_loop_desc: '最新のアップデート、ヒント、限定オファーを直接受信トレイに届けます。',
  footer_subscribe: '購読する',
  footer_subscribe_placeholder: 'メールアドレスを入力してください',
  footer_trusted_secure: '信頼と安全：',
  footer_ssl_secured: 'SSL保護',
  footer_ssl_secured_desc: '256ビットSSL',
  footer_aes_encryption: 'AES-256暗号化',
  footer_aes_encryption_desc: '銀行グレード',
  footer_kyc_compliant: 'KYC準拠',
  footer_kyc_compliant_desc: '確認済み',
  footer_gdpr_compliant: 'GDPR準拠',
  footer_gdpr_compliant_desc: 'データ保護',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: '認証済み',
  footer_platform: 'プラットフォーム',
  footer_support: 'サポート',
  footer_legal: '法的情報',
  footer_help_center: 'ヘルプセンター',
  footer_contact_us: 'お問い合わせ',
  footer_payments_label: '支払い方法：',
  home_live_activity_title: 'ライブプラットフォーム活動',
  home_recent_activity_title: '最近の活動',
  home_total_commissions_paid: '支払済手数料合計',
  home_active_users_online: 'オンラインアクティブユーザー',
  home_tasks_completed_today: '本日の完了タスク',
  account_security_tips_title: 'セキュリティ推奨事項',
  account_security_tips_desc: 'これらの簡単なベストプラクティスに従って、アカウントの保護を強化してください。',
  tip_password_title: '強力なパスワード',
  tip_password_desc: '文字、数字、記号を組み合わせて、アカウントの安全を確保してください。',
  tip_two_factor_title: '本人確認',
  tip_two_factor_desc: '重要なセキュリティ通知を受け取るために、連絡先情報を最新の状態に保ってください。',
  tip_logout_title: '定期的なログアウト',
  tip_logout_desc: '公共または共有のコンピュータを使用する場合は、必ずアカウントからログアウトしてください。',
  tip_sharing_title: 'アクセスを共有しない',
  tip_sharing_desc: '当社のサポートチームがパスワードを尋ねることはありません। 資格情報を誰とも共有しないでください।',

  // 注文リクエスト
  order_requests_title: '注文リクエスト',
  order_requests_desc: '新しいタスクまたはカスタム注文のリクエストを送信してください। 管理者がリクエストに基づいてタスクを確認し、割り当てます।',
  order_requests_new_btn: '注文をリクエスト',
  order_requests_table_id: 'リクエストID',
  order_requests_table_data: 'リクエスト詳細',
  order_requests_table_status: 'ステータス',
  order_requests_table_date: '送信日時',
  order_requests_table_actions: 'アクション',
  order_requests_cancel: 'キャンセル',
  order_requests_cancel_confirm: 'この注文リクエストをキャンセルしてもよろしいですか？',
  order_requests_cancel_success: '注文リクエストが正常にキャンセルされました।',
  order_requests_create_success: '注文リクエストが正常に送信されました।',
  order_requests_modal_title: '新しい注文リクエストを送信',
  order_requests_modal_desc: 'リクエストしたい注文に関する詳細情報を入力してください।',
  order_requests_field_data: '注文リクエストデータ',
  order_requests_field_placeholder: '例：プレミアムパッケージのカスタム注文をリクエストしたい।',
  order_requests_btn_submit: 'リクエストを送信',
  order_requests_btn_submitting: '送信中...',
  order_requests_empty: '注文リクエストは見つかりませんでした।',
  order_requests_status_pending: '保留中',
  order_requests_status_approved: '承認済み',
  order_requests_status_rejected: '却下',
  order_requests_status_cancelled: 'キャンセル済み',
  order_requests_terms_title: '法的拘束力のある注文規約',
  order_requests_term_1: '新しい注文は、承認後24〜48時間以内に割り当てられます。',
  order_requests_term_2: 'リリースされた注文は、キャンセル、一時停止、または変更することはできません。',
  order_requests_term_3: '割り当てられたすべての注文は、出金前に完了する必要があります。',
  order_requests_term_4: '注文を完了できなかった場合、アカウントのステータスに影響を与える可能性があります。',
  order_requests_term_5: 'このリクエストは最終的なものであり、送信後に取り消すことはできません。',
  order_requests_policy_title: 'キャンセル不可ポリシー',
  order_requests_policy_desc: 'このリクエストを送信することにより、新しい注文バッチが取り消し不能であることを認めるものとします。当社のシステムによって確認された後は、いかなる場合でもキャンセル、変更、または返金は許可されません。',
  order_requests_accept_terms: '私は上記の規約を読み、完全に理解しました。一度送信されたこの注文リクエストはキャンセルまたは変更できないことを認め、割り当てられたすべての注文を完了することに同意します。',

  // Orders Page (New Sections)
  orders_withdrawal_policy: '出金ポリシー',
  orders_unlock_req: 'ロック解除要件',
  orders_unlock_desc: '最初の{{count}}件の注文バッチを完了すると、出金機能が恒久的に解除されます。この一回限りの要件は、プラットフォームの整合性を確保し、不正利用を防止するためのものです。',
  orders_daily_limits: '1日の注文上限',
  orders_daily_limit_1: '1バッチにつき{{count}}件の注文 — 次のバッチをリクエストする前に、すべての注文を完了する必要があります',
  orders_daily_limit_2: '1日最大{{count}}バッチ（1日合計{{total}}件の注文）',
  orders_comm_rates: '手数料率',
  orders_comm_rates_desc: '手数料率は、プラットフォームおよび現在のウォレット残高によって決定されます：',
  orders_payout_timeline: '支払いスケジュール',
  orders_payout_desc: '出金は24〜48時間以内に処理されます。銀行振込には3〜5営業日かかる場合があります。暗号資産での出金は即時です。',
  orders_processing_fee: '取引コストをカバーするため、すべての出金に{{fee}}%の事務手数料が適用されます。',
  orders_tips_title: '成功のためのヒント',
  orders_tips_1: '毎日注文を完了してリズムを作り、収益を最大化しましょう',
  orders_tips_2: '適切な完了を確実にするため、処理中はページに留まってください',
  orders_tips_3: '定期的にウォレットをチェックして、手数料の増加を確認しましょう',
  orders_tips_4: '友達を紹介して、その友達の注文からボーナス手数料を獲得しましょう',
  orders_tips_5: '問題が発生した場合は、すぐにサポートにお問い合わせください',
  orders_batch_approx: '1バッチあたり{{count}}件の注文 × 平均${{avg}} = 1バッチあたり約${{total}}',

  // Settings
  settings_page_title: '設定',
  settings_page_desc: 'セキュリティ、プライバシー、設定の管理',
  settings_kyc_label: 'KYC認証',
  settings_kyc_desc: '本人確認',
  settings_security_label: 'セキュリティ',
  settings_security_desc: 'パスワード管理',
  settings_language_label: '言語',
  settings_language_desc: '地域設定',
  // 入金モーダル
  deposit_modal_title_method: "支払い方法を選択",
  deposit_modal_title_gateway: "暗号資産ウォレットを選択",
  deposit_modal_title_plan: "入金プランを選択",
  deposit_modal_title_details: "入金の詳細",
  deposit_modal_step_method: "方法",
  deposit_modal_step_gateway: "ウォレット",
  deposit_modal_step_plan: "プラン",
  deposit_modal_step_details: "詳細",
  deposit_modal_credit_card: "クレジットカード / デビットカード",
  deposit_modal_bank_transfer: "銀行振込",
  deposit_modal_ewallet: "電子マネー",
  deposit_modal_digital_currency: "デジタル通貨",
  deposit_modal_not_available: "お住まいの地域ではご利用いただけません",
  deposit_modal_available_recommended: "利用可能 — 推奨",
  deposit_modal_back_to_method: "支払い方法に戻る",
  deposit_modal_back_to_gateway: "ウォレットリストに戻る",
  deposit_modal_back_to_plan: "プランに戻る",
  deposit_modal_digital_selected: "デジタル通貨が選択されました",
  deposit_modal_digital_hint: "暗号資産ウォレットを選択して、アドレスと指示を受け取ってください。",
  deposit_modal_loading_wallets: "ウォレットを読み込み中...",
  deposit_modal_no_wallets: "利用可能な暗号資産ウォレットはありません。",
  deposit_modal_loading_plans: "プランを読み込み中...",
  deposit_modal_no_plans: "現在利用可能な入金プランはありません。",
  deposit_modal_duration: "期間",
  deposit_modal_amounts_profits: "金額と利益",
  deposit_modal_amount_label: "金額",
  deposit_modal_profit_label: "利益",
  deposit_modal_benefits: "特典",
  deposit_modal_continue: "次へ",
  deposit_modal_transfer_details: "{{name}} の振込詳細",
  deposit_modal_deposit_amount: "入金額",
  deposit_modal_amount_fixed: "選択したプランによって金額が固定されています",
  deposit_modal_txn_id: "トランザクションID",
  deposit_modal_txn_optional: "(任意)",
  deposit_modal_txn_placeholder: "例：0x1a2b3c4d...",
  deposit_modal_screenshot: "スクリーンショット",
  deposit_modal_upload_proof: "支払い証明をアップロード",
  deposit_modal_upload_hint: "PNG, JPG, JPEG — 最大5MB",
  deposit_modal_comments: "コメント",
  deposit_modal_comments_placeholder: "その他の情報...",
  deposit_modal_notice: "送信後、当チームが支払いを確認し、5〜30分以内にアカウントに入金されます。",
  deposit_modal_confirm: "入金を確定する",
  deposit_modal_submitting: "送信中...",
  deposit_modal_err_fields: "すべての必須項目を入力してください",
  deposit_modal_err_submit: "送信中にエラーが発生しました",
  deposit_modal_success: "入金リクエストが正常に完了しました！",
  deposit_modal_err_plans: "入金プランの読み込みに失敗しました",
  deposit_modal_err_wallets: "支払い方法の読み込みに失敗しました",
  deposit_modal_new_to_crypto: "New to crypto? Learn how to buy digital currency",
  deposit_modal_crypto_label: "暗号資産",
  orders_insufficient_balance: "Insufficient Balance",
  orders_balance_gap_msg1: "Your current balance is not enough to complete this order.",
  orders_balance_gap_msg2_start: "Please add",
  orders_balance_gap_msg2_end: "to proceed and unlock your commission.",
  orders_btn_add_funds: "Add Funds",
};
